import { render } from "./LakalaWechatPayment.vue?vue&type=template&id=5f417519&scoped=true"
import script from "./LakalaWechatPayment.vue?vue&type=script&lang=js"
export * from "./LakalaWechatPayment.vue?vue&type=script&lang=js"

import "./LakalaWechatPayment.vue?vue&type=style&index=0&id=5f417519&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f417519"]])

export default __exports__